<div *ngIf="isPageReady" class="flex flex-col gap-4 p-4">
  <!-- Summary -->
  <div class="text-lg font-semibold">Invoice {{ invoiceId }} - Freight Calculation</div>

  <!-- Key Values -->
  <div class="grid grid-cols-2 gap-2 text-sm">
    <div class="font-medium">Base Shipment Freight:</div>
    <div>{{ formatCurrency(totalShipmentFreight) }}</div>

    <div class="font-medium">Amount Charged on This Invoice:</div>
    <div class="font-bold text-primary">{{ formatCurrency(actualChargedFreight) }}</div>
  </div>

  <!-- Explanation -->
  <div class="p-3 bg-surface-100 rounded-lg">
    <div class="font-medium mb-2">Explanation:</div>
    <div class="text-sm">{{ explanationText }}</div>
  </div>

  <!-- Flags Section -->
  <div class="border rounded-lg p-3">
    <div class="font-medium mb-2">Business Rules Applied:</div>
    <div class="grid grid-cols-2 gap-2 text-sm">
      <div class="flex items-center gap-2">
        <i [class]="isPrimaryInvoice ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"></i>
        <span>Is Primary Invoice</span>
      </div>
      <div class="flex items-center gap-2">
        <i [class]="isFirstShipmentInvoice ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"></i>
        <span>Is First Shipment on This Order</span>
      </div>
      <div class="flex items-center gap-2">
        <i [class]="doesAccountPayFreight ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"></i>
        <span>Account Pays Freight</span>
      </div>
      <div class="flex items-center gap-2">
        <i [class]="shouldChargeFreightOnFirstShipmentOnly ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-gray-400'"></i>
        <span>Charge Freight on 1st Shipment Only</span>
      </div>
      <div class="flex items-center gap-2" *ngIf="hasThirdPartyCarrier">
        <i class="pi pi-truck text-blue-500"></i>
        <span>Third-Party Carrier: {{ carrierAccountName }}</span>
      </div>
    </div>
  </div>

  <!-- Related Invoices Table (if multiple) -->
  <div *ngIf="relatedInvoices.length > 1" class="border rounded-lg p-3">
    <div class="font-medium mb-2">Invoices in This Shipment:</div>
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b">
          <th class="text-left py-1">Invoice ID</th>
          <th class="text-right py-1">Subtotal</th>
          <th class="text-center py-1">First Shipment?</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let inv of relatedInvoices" [class.bg-primary-50]="inv.id === invoiceId">
          <td class="py-1">
            {{ inv.id }}
            <span *ngIf="inv.id === invoiceId" class="text-xs text-primary ml-1">(this invoice)</span>
          </td>
          <td class="text-right py-1">{{ formatCurrency(inv.subtotal) }}</td>
          <td class="text-center py-1">
            <i [class]="inv.isFirstShipment ? 'pi pi-check text-green-500' : 'pi pi-times text-gray-400'"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Proportional calculation breakdown if applicable -->
    <div *ngIf="shouldChargeFreightOnFirstShipmentOnly && !allFirstShipment" class="mt-3 p-2 bg-amber-50 rounded text-sm">
      <div class="font-medium">Proportional Calculation:</div>
      <div>
        Since "First Shipment Only" is enabled and this shipment contains mixed invoice types, freight is calculated proportionally based on
        the subtotals of charge-freight invoices.
      </div>
    </div>
  </div>

  <!-- Close Button -->
  <div class="flex justify-end pt-2">
    <button pButton type="button" class="p-button-raised" (click)="close()">
      <span>Close</span>
    </button>
  </div>
</div>
